import React, { FC, MouseEvent, ReactElement, useCallback, useState } from "react";

import { faCaretDown } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import styles from "@app/scene/dashboard/components/Sidebar/components/ScopeList/components/CollapsibleScopeItem.module.scss";
import ScopeItem, {
  ScopeItemProps,
} from "@app/scene/dashboard/components/Sidebar/components/ScopeList/components/ScopeItem";

interface Props extends Omit<ScopeItemProps, "prefix"> {
  children: ReactElement<ScopeItemProps>[];
  defaultCollapsed?: boolean;
}

const CollapsibleScopeItem: FC<Props> = ({
  children,
  className,
  defaultCollapsed,
  ...scopeItemProps
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const [hidden, setHidden] = useState(false);
  const handleArrowClick = useCallback((e: MouseEvent) => {
    setCollapsed((collapsed) => {
      e.preventDefault();
      e.stopPropagation();

      if (collapsed) {
        setHidden(false);
      }
      return !collapsed;
    });
  }, []);

  const handleTransitionEnd = useCallback(() => {
    if (collapsed) {
      setHidden(true);
    }
  }, [collapsed]);

  return (
    <div className={styles.container}>
      <ScopeItem
        className={cn(styles.header, className)}
        {...scopeItemProps}
        prefix={
          <span className={styles.iconContainer} onClick={handleArrowClick}>
            <FontAwesomeIcon
              className={cn(styles.icon, { [styles.collapsedIcon]: collapsed })}
              icon={faCaretDown}
            />
          </span>
        }
      />
      <div
        className={cn(styles.content, {
          [styles.collapsed]: collapsed,
          [styles.hidden]: hidden && collapsed,
        })}
        onTransitionEnd={handleTransitionEnd}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapsibleScopeItem;
